import React, { Component } from "react";
import { connect } from "react-redux";
import i18next from "i18next";
import { withTranslation, Trans } from "react-i18next";
import classnames from "classnames";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import HomeIcon from "@material-ui/icons/Home";
import AddIcon from "@material-ui/icons/Add";
import NotificationsIcon from "@material-ui/icons/Notifications";
import SlideshowIcon from "@material-ui/icons/Slideshow";
import imgUrl from "../assets/images/imageUrl.js";
import Homemenu from "./HomeMenuList";
import Tour from "reactour";
import { Link, useHistory, withRouter } from "react-router-dom";
import Services from "../api/api";
import { auth } from "../service/firebase";
import OffileDb from '../config/pouchDB';
import Loader from "./loaders/loader";
import BottomAppBar from './Layout/Bottomnav';
import {
  setSelectedComponentObject,
  resetSelectedCompnentObject,
  setBottomNavComponentObject,
  partialSetSelectedComponentObject,
  setcomponentbgcolor
} from "../redux/actions/appActions";

// let steps = []

class Homepage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      isTourOpen: false,
      steps: [],
      tourObj: {},
      headerLogo: imgUrl.logo,
      footerLogo: imgUrl.poweredby,
    };
    this.closeTour = this.closeTour.bind(this);
    this.openTour = this.openTour.bind(this);
    //this.addtourguideSteps = this.addtourguideSteps(this)
  }

  componentDidMount() {
    OffileDb.setDatabase()
    //this.checkUserExist()
    //this.getTourGuide();
    this.getAppLogos();
    this.getTranslation()
    sessionStorage.removeItem("activeTab");
  }


  getTranslation(id) {
    var params = {
      communityId: this.props.communityuid,
      labelType: 'Mobile',
      languageId: this.props.langId
    };
    Services.getCommunitywiseLabels(params).then((res) => {
      try{
        console.log("getCommunitywiseLabels>>", res);
        if (res.data.status == 200) {
          let lan = res.data.data.locale;
          let tran = res.data.data.label;
          document.getElementsByTagName("body")[0].setAttribute("lag", lan);
          i18next.addResourceBundle(lan, "translations", tran, true, true);
          i18next.changeLanguage(lan);
          OffileDb.setData("tranlation", res.data.data)
        }
      }catch(err){
        console.log("err::", err)
      }
    });
  }

  checkUserExist() {
    var uuid = window.cordova ? window.device.uuid : localStorage.getItem("deviceuuid");
    var para = {
      "communityId": this.props.communityuid,
      "serialNumber": uuid //param.deviceDetails.serialNumber,
    }
    console.log(para)
    var currentid = localStorage.getItem("templateID");
    try {
      Services.checkIfApplicantExists(para).then((res) => {
        console.log(res)
        try{
          if (res && res.data) {
            this.getAppLogos();
          } else {
            OffileDb.deleteDatabse();
            localStorage.clear();
            localStorage.setItem("templateID", currentid);
            this.props.history.push("/Onboarding");
          }
        }catch(err){
          console.log("err::", err)
        }
      })

    } catch (e) {
      console.log(e)
    }

  }

  getAppLogos() {
    if (navigator.onLine) {
      var param = {
        communityId: this.props.communityuid,
      };
      Services.getCommunityBrandingByCommunityId(param).then((res) => {
        try{
          console.log(res)
          if (res.status == 200) {
            let hlogo = res.data.data.brandingDetails.filter(o => o.tagline == "headerlogo").map(o => o.icon)[0] || imgUrl.logo;
            let flogo = res.data.data.brandingDetails.filter(o => o.tagline == "footerlogo").map(o => o.icon)[0] || imgUrl.stoptblogo;
            this.setState({
              headerLogo: hlogo,
              footerLogo: flogo,
              isLoading: false
            });
            OffileDb.setData('applogos', res.data.data)
          } else {
            this.setState({
              isLoading: false
            });
          }
        }catch(err){
          console.log("err::", err)
        }
      })
    } else {
      this.setState({
        isLoading: false
      });
    }
  }

  getTourGuide(menulist) {
    this.loadOfflineTourguide(menulist)
  }

  getTourGuideApi(menulist) {
    const { templateID } = this.props;
    if (navigator.onLine) {
      var params = {
        "communityId": this.props.communityuid,
        "contentId": 75,
        "languageId": this.props.langId
      };
      Services.getStaticContent(params).then((res) => {
        try {
          if (res.data.status == 200) {
            this.setState({
              tourObj: res.data.data.contentList[0].extension
            })
            OffileDb.setData("tourguide", res.data.data.contentList[0].extension);
            this.addtourguideSteps(res.data.data.contentList[0].extension, menulist)
          }
        } catch (err) {
          console.log("err::", err)
        }
      });
    } else {
      if (templateID == 2) {
        this.resizeHomeItmes();
      }
    }
  }

  loadOfflineTourguide(menulist) {
    var that = this;
    OffileDb.getData("tourguide").then(function (result) {
      if (!result.status && result.status != 404) {
        that.setState({
          tourObj: result.data,
        });
        that.addtourguideSteps(result.data, menulist)
      } else {
        that.getTourGuideApi(menulist);
      }
    });
  }

  closeTour() {
    this.setState({ isTourOpen: false });
  }

  openTour() {
    this.setState({ isTourOpen: true });
  }

  resizeHomeItmes() {
    var homelinkbtn = document.getElementsByClassName('homemenu-linkbtn');
    var homelist = document.getElementsByClassName('homemenulisting');
    var homemenuicon = document.getElementsByClassName('homemenuicon');

    var containerHeight = document.getElementsByClassName('homepagedivcontent')[0].offsetHeight;

    var hoemItemHeight = parseInt(containerHeight / homelinkbtn.length) + 'px';
    console.log(hoemItemHeight)
    console.log(containerHeight)
    for (var i = 0; i < homelinkbtn.length; i++) {
      homelinkbtn[i].style.height = hoemItemHeight;
    }
    for (var i = 0; i < homelist.length; i++) {
      homelist[i].style.height = hoemItemHeight;
    }
    for (var i = 0; i < homemenuicon.length; i++) {
      homemenuicon[i].style.height = hoemItemHeight
    }
  }

  resizeHomeItmesTempalte1() {
    var homelist = document.getElementsByClassName('homepagegrid_bgmenu');
    var containerHeight = document.getElementsByClassName('homepagegrid_bgmenu')[0].offsetHeight;
    for (var i = 0; i < homelist.length; i++) {
      homelist[i].style.height =  parseInt(containerHeight) + 'px';
    }
  }



  addtourguideSteps(obj, menulist) {
    const { templateID } = this.props;
    let steps = [];
    Object.entries(obj).forEach(entry => {
      const [key, value] = entry;
      let clas = key.split(" ").join("");
      if (menulist.includes(key)) {
        steps.push({
          selector: "." + clas,
          content: value,
        });
      }
    })

    var flag = JSON.parse(localStorage.getItem("isTourOpen"));
    if (flag != null) {
      this.setState({ isTourOpen: flag });
      localStorage.removeItem("isTourOpen");
    }

    this.setState({
      steps: steps,
    });
    
    if(templateID == 1) {
      //this.resizeHomeItmesTempalte1();
    } else if(templateID == 2){
      this.resizeHomeItmes();
    }
  }

  handleClickSetting(menuobj) {
    this.setState({
      isSettingSelected: true,
    })
    localStorage.setItem('componentbgcolor', "#009596")
    this.props.setcomponentbgcolor("#009596")
    this.props.setBottomNavComponentObject({});
    this.props.partialSetSelectedComponentObject({});
    this.props.history.replace({
      pathname: menuobj.pathname,
      state: {},
    });
  }


  render() {
    const { t } = this.props;
    const { templateID } = this.props;
    return (
      <div className="onboarding-page homemenu_gridpage" >
        {
          templateID == 1 && (
            <div className="backgroundivholder">
              <div className="bgdiv1">
                <div class="welcometopcurve">
                  <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z" class="shape-fill"></path>
                  </svg>
                </div>
              </div>
              <div className="bgdiv2"></div>
            </div>
          )
        }
        <div className="gridcontainer welcome-login-page">
          <Grid container spacing={3} className="gridcontainer">
            <Grid item xs={12} className="zero">
              <div className="homepageheaderdiv">
                <Grid container spacing={2} className="gridcontainer">
                  <Grid item xs={1} className="zero">
                    <Link
                      onClick={() =>
                        this.handleClickSetting({
                          pathname: `/layout/settings`,
                          state: {
                            name: "settings",
                          },
                        })
                      }
                    >
                      <IconButton
                        edge="start"
                        className="menubtn"
                        color="inherit"
                        aria-label="menu"
                      >
                        <MenuIcon />
                      </IconButton>
                    </Link>
                  </Grid>

                  <Grid item xs={10} className="zero appnameholder">
                    {
                      templateID == 1 ? (
                        <h3 className="zero text-center">{t('iMonitor')}</h3>
                      ) : (
                        <p className="zero text-center">
                          {this.state.isLoading ? (
                            <Loader isLoading={this.state.isLoading} />
                          ) : (<img className="stoptblogoimg" src={this.state.headerLogo} />)
                          }
                        </p>
                      )
                    }
                  </Grid>
                  <Grid item xs={1} className="zero">
                    <IconButton
                      edge="start"
                      className="menubtn"
                      color="inherit"
                      aria-label="home"
                      className="homeicon-btn  tourguideBtn"
                      onClick={this.openTour}
                    >
                      <SlideshowIcon />
                    </IconButton>
                  </Grid>
                </Grid>
                <Grid container spacing={2} className="gridcontainer">
                  <Grid item xs={12} className="zero">
                    <p className="getonboardedtext text-center"> <Trans> {t("HOMEPAGE")} </Trans></p>
                  </Grid>
                </Grid>
                {
                  templateID != 1 && (
                    <div className="custom-shape-divider-bottom-1599722124">
                      <svg
                        data-name="Layer 1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 1200 120"
                        preserveAspectRatio="none"
                      >
                        <path
                          d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z"
                          className="shape-fill"
                        ></path>
                      </svg>
                    </div>
                  )
                }
              </div>
            </Grid>

            <Grid item xs={12} className={templateID != 1 ? "homepagedivcontent" : ""}>
              <Homemenu setTourGuide={(menulist) => this.getTourGuide(menulist)} />
            </Grid>
          </Grid>
        </div>
        {this.state.steps.length != 0 &&
          <Tour 
            accentColor="#4e61bf"
            steps={this.state.steps}
            isOpen={this.state.isTourOpen}
            onRequestClose={this.closeTour}
          />
        }

      </div>
    );
  }
}
// const FinalHomepage = withRouter(withTranslation()(Homepage));

// export default FinalHomepage;
const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
  };
};

const TranslationHomepage = withTranslation()(Homepage);
const FinalHomepage = withRouter(TranslationHomepage);

export default connect(mapStateToProps, {
  setSelectedComponentObject,
  resetSelectedCompnentObject,
  setBottomNavComponentObject,
  partialSetSelectedComponentObject,
  setcomponentbgcolor
})(FinalHomepage);
